import {
  SUPER_SYSTEM_BETSLIP_COUPONS_REQUEST,
  SUPER_SYSTEM_BETSLIP_COUPONS_SUCCESS,
  SUPER_SYSTEM_BETSLIP_COUPONS_FAILURE,
  SUPER_SYSTEM_BETSLIP_SUMMARY_REQUEST,
  SUPER_SYSTEM_BETSLIP_SUMMARY_SUCCESS,
  SUPER_SYSTEM_BETSLIP_SUMMARY_FAILURE
} from 'Store/constants';

const initialState = {
  coupons: {
    data: [],
    isLoading: false,
    error: null
  },
  summary: {
    data: {},
    isLoading: false,
    isFetched: null,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUPER_SYSTEM_BETSLIP_COUPONS_REQUEST:
      return {
        ...state,
        coupons: {
          ...state.coupons,
          isLoading: true,
          error: null
        }
      };
    case SUPER_SYSTEM_BETSLIP_COUPONS_SUCCESS:
      return {
        ...state,
        coupons: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SUPER_SYSTEM_BETSLIP_COUPONS_FAILURE:
      return {
        ...state,
        coupons: {
          ...state.coupons,
          isLoading: false,
          error: action.payload
        }
      };

    case SUPER_SYSTEM_BETSLIP_SUMMARY_REQUEST:
      return {
        ...state,
        summary: {
          ...state.summary,
          isLoading: true,
          isFetched: null,
          error: null
        }
      };

    case SUPER_SYSTEM_BETSLIP_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: {
          data: { ...action.payload },
          isLoading: false,
          isFetched: true,
          error: null
        }
      };

    case SUPER_SYSTEM_BETSLIP_SUMMARY_FAILURE:
      return {
        ...state,
        summary: {
          ...state.coupons,
          isLoading: false,
          error: action.payload
        }
      };

    default:
      return state;
  }
};
